import { ColorConf } from '@/config/color';
import { logEvent } from '@/lib/firebaseConfig';
import { Button, styled } from '@mui/material';
import { Box } from '@mui/material';
import React from 'react'
import { useRouter } from "next/router";

const ButtonWrapper = styled(Box)({
  position: "absolute",
  bottom: "10%",
  display: "flex",
  flexDirection: "column",
});
const StyledSubmitButton2 = styled(Button)({
  marginLeft: "auto",
  marginRight: "auto",
  width: 231,
  height: 44,
  textAlign: "center",
  borderRadius: 13,
  marginBottom: 10,
  fontFamily: "kozuka-gothic-pr6n, sans-serif",
  fontSize: 19,
  lineHeight: "20px",
  fontWeight: 500,
  boxShadow: "none",
  textTransform: "none",
  color: ColorConf.White,
  backgroundColor: ColorConf.HeroPrimaryColor,
  borderColor: ColorConf.HeroPrimaryColor,
  "&:hover": {
    backgroundColor: ColorConf.HeroPrimaryColor,
    boxShadow: `0px 0px 10px ${ColorConf.HeroPrimaryColor}`
  },
  "@media (min-width: 600px)": {
    width: 284,
    height: 48,
  }
});

interface AuthButtonsProps {
  customStyles?: React.CSSProperties;
}

const AuthButtons = ({ customStyles }: AuthButtonsProps) => {
  const router = useRouter();

  return (
    <ButtonWrapper style={customStyles}>
      <StyledSubmitButton2
        onClick={() => {
          logEvent("button_signUp_clicked", {});
          router.push("/signUp");
        }}
      >
        無料で始める
      </StyledSubmitButton2>
      <StyledSubmitButton2
        onClick={() => {
          logEvent("button_login_clicked", {});
          router.push("/signIn");
        }}
      >
        ログイン（登録済の方）
      </StyledSubmitButton2>
    </ButtonWrapper>
  )
}

export default AuthButtons